<template>
  <div class="footer">
    <div class="home">
      <div class="left_f">
        <p class="footer_bottom" style="padding-top: 100px;">Copyright © 1998-{{ new Date().getFullYear() }} DRCnet. All Rights Reserved</p>
        <p class="footer_bottom">版权所有 
          <a href="https://www.drcnet.com.cn/" target="_blank">国研网</a>
          </p>
      </div>
      
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      newYear: new Date().getFullYear(),
    };
  },
  watch: {
    MobileVerification: {
      handler(to) {
      },
      immediate: true,
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.footer {
  color: #fff;
  height: 200px;
  background: #fff;
  padding-top: 0;
  margin-top: 0;
  // position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.left_f{
  text-align: center;
  p{
    color: #000;
  }
}

.right_f {
  text-align: center;
  width: 122px;
}
.right_f img {
  width: 110px;
  margin: 0 auto;
}
.right_f p {
  font-size: 12px;
  color: #797b80;
  padding-top: 10px;
}
.bottom-f {
  color: #797b80;
  background: #20242c;
  height: 45px;
  line-height: 45px;
  margin-top: 30px;
  a {
    color: #797b80;
    display: inline-block;
  }
  .bq li {
    float: left;
    span {
      color: #797b80;
      font-size: 12px;
    }
    img {
      padding-left: 7px;
      padding-top: 12px;
      padding-right: 0px;
    }
  }
}
.tel {
  width: 400px;
  padding-top: 50px;
  img {
    padding-right: 15px;
  }
}
.tel .hm p,
.hm span,
.footer_bottom {
  font-size: 14px;
  padding-top: 20px;
  color: #ffffff;
  font-family: Microsoft YaHei;
}
.tel .hm p {
  font-size: 22px;
}
.hmd {
  span {
    font-size: 16px;
  }
  p {
    padding-top: 10px !important;
    font-size: 22px;
  }
}
.dtgif {
  position: relative;
  left: -50px;
  display: none;
}
.ewm li {
  float: right;
  margin-left: 20px;
}
.ewm li img {
  width: 108px;
  height: 108px;
}
.menu a {
  font-size: 15px;
}
.right_f_wx {
  min-width: 335px;
  margin-top: 44px;
  text-align: center;
}
.right_f_wx p {
  font-size: 14px;
  color: #d7d5d6;
  padding-top: 10px;
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 769px) {
  .footer {
    max-width: 100% !important;
    margin: 0 auto;
    .home {
      width: 100% !important;
    }
    .tel {
      padding-top: 30px !important;
      width: 100% !important;
      text-align: center;
      display: flex;
      margin-left: -10px !important;
      justify-content: center;
    }
    .footer_bottom {
      text-align: center;
      padding: 10px 20px 0 20px !important;
    }
    .bottom-f {
      height: 70% !important;
      font-size: 12px;
      padding: 0 20px;
      a {
        display: contents !important;
      }
    }
  }
}
</style>
